module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABICAYAAABhlHJbAAAAAXNSR0IArs4c6QAAAWFJREFUeAHt1TFKA0EUANBdhaQPNoJ3sE/lHTxHWg9hmzt4Ag9gnc47WKcQm2yx6wxkCIR1doSRhfgWwiT5/8//+9hlmsZFgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIXJpA+xc3tNls7rquex6G4SHu37bt22KxeNputx8l/eauL5kx5VQHjDd/OBzeQ4NVanJc98vl8n4Kce76s5knf15NZvwyIT55oeQcL+6yOsayO85dnx1uJFgdML22I72aXCzl53JysVr1aZ/StTpgaeNLyasOGA+Mn3BysVSTy8nFatWnfUrX6oDxtA3N9yMD7I+xkdDpr7nrT5OUfbsuSyvP2u12n+v1+qXv+9tQdRM+X+HJeQ0n8OPUCRy7zF0fZ3ARIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAEC/1vgG7r3moHepng+AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/more@2x.png
// module id = hGdB
// module chunks = 0